import { render, staticRenderFns } from "./OptimizedImage.vue?vue&type=template&id=6e04c962&scoped=true"
import script from "./OptimizedImage.vue?vue&type=script&lang=js"
export * from "./OptimizedImage.vue?vue&type=script&lang=js"
import style0 from "./OptimizedImage.vue?vue&type=style&index=0&id=6e04c962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e04c962",
  null
  
)

export default component.exports